module.exports = __webpack_public_path__ + "img/minus.717b5756.svg";